import React, { useState } from "react";
import { NavLink, useMatch, useResolvedPath } from "react-router-dom";
import useWindowSize from "../hooks/useWindowSize";

// Data for the menu items
const menuData = [
  { label: "Nosotros", to: "/nosotros", exact: true },
  {
    label: "Naturopatía Alimentaria",
    to: "/naturopatia-alimentaria",
    exact: true,
    submenu: [
      { label: "Pérdida de Peso", to: "/naturopatia-alimentaria/perdida-peso" },
      { label: "Mantenimiento", to: "/naturopatia-alimentaria/mantenimiento" },
      { label: "Soporte On-Line", to: "/naturopatia-alimentaria/soporte-online" },
    ]
  },
  {
    label: "Psicología",
    to: "/psicologia",
    exact: true,
    submenu: [
      { label: "Sesiones Grupales", to: "/psicologia/sesiones-grupales" },
      { label: "Para Adultos", to: "/psicologia/adultos" },
      { label: "Para Adolescentes", to: "/psicologia/adolescentes" },
      { label: "Para Deportistas", to: "/psicologia/deportistas" }
    ]
  },
  {
    label: "Otros servícios",
    to: "/otros-servicios",
    exact: true,
    submenu: [
      { label: "Opositores", to: "/otros-servicios/opositores" },
      { label: "Corredores", to: "/otros-servicios/corredores" },
      { label: "Aumento de Masa Muscular", to: "/otros-servicios/aumento-masa-muscular" },
      { label: "Servicios a Empresas", to: "/otros-servicios/servicios-a-empresas" }
    ]
  },
  { label: "El Equipo", to: "/equipo", exact: true },
  { label: "Blog", to: "/blog", exact: true }
];

// Recursive component for rendering a menu item (with optional subitems)
const DynamicMenuItem = ({ item }) => {
  const resolved = useResolvedPath(item.to);
  const match = useMatch({ path: resolved.pathname, end: item.exact ?? false });
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const windowSize = useWindowSize();

  const handleToggleSubmenu = (e) => {
    // Only handle toggle for smaller screens
    if (windowSize.width <= 1200) {
      e.preventDefault();
      setIsSubmenuOpen(!isSubmenuOpen);
    }
  };

  return (
    <li className={`mega-menu-item ${match ? "active" : ""} ${isSubmenuOpen ? "active" : ""}`}>
      {item.submenu && item.submenu.length > 0 ? (
        <NavLink
          to={item.to}
          onClick={handleToggleSubmenu}
          className={isSubmenuOpen ? "active" : ""}
        >
          {item.label}
        </NavLink>
      ) : (
        <NavLink to={item.to}>{item.label}</NavLink>
      )}

      {item.submenu && item.submenu.length > 0 && (
        <ul className={`mega-submenu ${isSubmenuOpen ? "active" : ""}`}>
          {item.submenu.map((subitem, index) => (
            <DynamicMenuItem key={index} item={subitem} />
          ))}
        </ul>
      )}
    </li>
  );
};

const MainMenu = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMenuClick = (e) => {
    e.preventDefault();
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div className="menu-link">
      <div
        className={`btn-show-menu-mobile menubar menubar--squeeze ${mobileMenuOpen ? "active" : ""}`}
        onClick={handleMenuClick}
      >
        <span className="menubar-box">
          <span className="menubar-inner"></span>
        </span>
      </div>
      {/* Main menu */}
      <nav className={`main-menu menu-mobile ${mobileMenuOpen ? "show" : ""}`} id="menu">
        <ul className="menu">
          {menuData.map((item, index) => (
            <DynamicMenuItem key={index} item={item} />
          ))}
        </ul>
      </nav>
      {/* Main menu end */}
    </div>
  );
};

export default MainMenu;
